<template>
    <div>
        <div class="Main" style="padding-bottom:0;">
            <div class="topMain">
                <div slot="header" class="clearfix">
                    <span>数据推送日志</span>
                </div>
            </div>
            <div style="margin-top: 15px;">
                <!-- <el-card class="box-card"> -->
                <el-form :model="queryParams" ref="queryParams" :inline="true" class="demo-form-inline">
                    <el-form-item label="设备编号" prop="devCode">
                        <el-input placeholder="请输入" v-model="queryParams.devCode"></el-input>
                    </el-form-item>
                    <el-form-item label="设备名称" prop="devName">
                        <el-input placeholder="请输入" v-model="queryParams.devName"></el-input>
                    </el-form-item>
                    <el-form-item label="推送地址" prop="pushUrl">
                        <el-input placeholder="请输入" v-model="queryParams.pushUrl"></el-input>
                    </el-form-item>
                    <el-form-item label="推送类型" prop="pushType">
                        <el-select placeholder="请选择" v-model="queryParams.pushType">
                            <el-option label="设备json数据" value="1"></el-option>
                            <el-option label="设备上下线消息" value="2"></el-option>
                            <el-option label="设备告警数据" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="推送方式" prop="pushMode">
                        <el-select placeholder="请选择" v-model="queryParams.pushMode">
                            <el-option label="HTTP" value="1"></el-option>
                            <el-option label="RabbitMQ" value="2"></el-option>
                            <el-option label="Kafka" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态" prop="pushStatus">
                        <el-select placeholder="请选择" v-model="queryParams.pushStatus">
                            <!-- <el-option label="进行中" value="0"></el-option>
                            <el-option label="成功" value="1"></el-option> -->
                            <el-option label="失败" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-date-picker v-model="createTime" type="datetimerange" range-separator="至"
                            start-placeholder="开始日期" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd  HH:mm"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class=" checkPlandiv_but">
                        <el-button type="primary" @click="getList()">搜索</el-button>
                        <el-button @click="resetQuery"><i class="el-icon-refresh"></i>重置</el-button>
                    </el-form-item>
                </el-form>
                <!-- </el-card> -->
            </div>
            <div>
                <el-card class="box-card" style="margin-top: 30px;">
                    <el-table :data="resultPage" style="width: 100%">
                        <el-table-column label="序号" type="index" width="50">
                        </el-table-column>
                        <el-table-column prop="devCode" label="设备编号" width="" />
                        <el-table-column prop="devName" label="设备名称" width="" />
                        <el-table-column prop="pushType" label="推送类型" width="">
                            <template slot-scope="scope">
                                {{ scope.row.pushType == 1 ? '设备json数据' : scope.row.pushType == 2 ? '设备上下线消息' : '设备告警数据'
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="pushMode" label="推送方式" width="">
                            <template slot-scope="scope">
                                {{ scope.row.pushMode == 1 ? 'HTTP' : (scope.row.pushMode == 2 ? 'RabbitMQ' : 'Kafka' )
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="pushUrl" label="推送地址" width="" />
                        <el-table-column prop="pushStatus" label="状态" width="">
                            <template slot-scope="scope">
                                {{ scope.row.pushStatus == 0 ? '进行中' : scope.row.pushStatus == 1 ? '成功' : '失败' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="createDate" label="创建时间" width="" />
                        <el-table-column label="操作" width="">
                            <template slot-scope="scope">
                                <el-button class="el-icon-s-order" type="text"
                                    @click="handleDetails(scope.row)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                </el-card>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="queryParams.currentPage" :page-sizes="[10, 20, 50, 100]"
                    :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <DataPushDetail ref="DataPushDetail"></DataPushDetail>
    </div>
</template>

<script>
    import API from "../../api/api";
    import DataPushDetail from "./DataPushDetail.vue"
    export default {
        components: {
            DataPushDetail,
        },
        data() {
            return {
                queryParams: {
                    devCode: '',
                    devName: '',
                    pushUrl: null,
                    pushType: null,
                    pushMode: null,
                    pushStatus: null,
                    createTimeBegin: '',
                    createTimeEnd: '',
                    currentPage: 1,
                    pageSize: 10,
                },
                createTime: null,
                resultPage: [],
                total: 0
            }
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                if (this.createTime) {
                    this.queryParams.createTimeBegin = this.createTime[0]
                    this.queryParams.createTimeEnd = this.createTime[1]
                } else {
                    this.queryParams.createTimeBegin = null
                    this.queryParams.createTimeEnd = null
                }
                API.platformPushLogList(this.queryParams).then(res => {
                    this.resultPage = res.data.resultPage
                    this.total = res.data.total
                })
            },
            // 详情
            handleDetails(row) {
                this.$refs.DataPushDetail.show(row)
            },
            //分页
            handleSizeChange(val) {
                console.log('handleSizeChange', val)
                this.queryParams.pageSize = val;
                this.queryParams.currentPage = 1;
                this.getList()
            },
            handleCurrentChange(val) {
                console.log('handleCurrentChange', val)
                this.queryParams.currentPage = val;
                this.getList()
            },
            // 重置resetQuery
            resetQuery() {
                this.$nextTick(() => {
                    this.$refs["queryParams"].resetFields();
                    this.createTime = null
                    this.queryParams.currentPage = 1
                    this.getList();
                })
            }
        },
    }
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/views/platform/DataPush.vue